/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { pxToVw } from 'src/functions/units'
import styled, { css } from 'styled-components'

import BrandLogo from '../Common/BrandLogo'
import Icon from '../Icon'
import automataLogoImage from '../../assets/automata-logo.png'

const medias = [
  {
    icon: 'twitter',
    title: 'twitter',
    href: 'https://twitter.com/AutomataNetwork'
  },
  {
    icon: 'discord',
    title: 'discord',
    href: 'https://discord.com/invite/dCCjWK86TF'
  },
  { icon: 'telegram', title: 'telegram', href: 'https://t.me/ata_network' },
  { icon: 'medium', title: 'medium', href: 'https://medium.com/atanetwork' },
  {
    icon: 'github',
    title: 'github',
    href: 'https://github.com/automata-network'
  }
]

const linkGroups = [
  {
    title: 'Middlewares',
    links: [
      {
        title: 'Conveyor',
        href: 'https://docs.ata.network/conveyor/overview/'
      },
      {
        title: 'Witness',
        href: 'https://witness.ata.network/'
      }
    ]
  },
  {
    title: 'Other Products',
    links: [
      {
        title: 'NFTFair',
        href: 'https://www.nftfair.app/'
      },
      {
        title: 'AnyDAO',
        href: 'https://www.anydao.app/'
      },
      {
        title: 'XATA',
        href: 'https://www.xata.fi/'
      }
    ]
  },
  {
    title: 'Resources',
    links: [
      {
        title: 'Documentation',
        href: 'https://docs.ata.network/'
      },
      {
        title: 'Lightpaper',
        href: 'https://docs.ata.network/papers/lightpaper.pdf'
      }
    ]
  },
  {
    title: 'About',
    links: [
      {
        title: 'Automata Network',
        href: 'https://www.ata.network/'
      },
      {
        color: '#ff8a00',
        title: 'Careers',
        href: 'https://www.ata.network/careers'
      }
    ]
  }
]

const Footer = () => {
  return (
    <StyledFooter>
      <StyledFooterMainContent>
        <StyledFooterLeftColumn>
          <BrandLogo altText="Automata logo" logo={automataLogoImage} />

          <StyledFooterMediasTitle>Stay in touch</StyledFooterMediasTitle>

          <StyledFooterMedias>
            {medias.map((item) => {
              return (
                <StyledFooterMedia
                  key={item.href}
                  target="_blank"
                  rel="noreferrer"
                  title={item.title}
                  href={item.href}
                >
                  <StyledFooterMediaIcon icon={item.icon as any} size={22} color="#d3d3d3" />
                </StyledFooterMedia>
              )
            })}
          </StyledFooterMedias>
        </StyledFooterLeftColumn>

        <StyledFooterRightColumn>
          {linkGroups.map((item) => {
            return (
              <StyledFooterLinksColumn key={item.title}>
                <StyledFooterLinksColumnTitle>{item.title}</StyledFooterLinksColumnTitle>
                {item.links.map((link) => {
                  return (
                    <StyledFooterLink
                      href={link.href}
                      key={link.href}
                      style={{ color: link.color }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {link.title}
                    </StyledFooterLink>
                  )
                })}
              </StyledFooterLinksColumn>
            )
          })}
        </StyledFooterRightColumn>
      </StyledFooterMainContent>

      <StyledFooterCopyrights>
        &copy; 2022 Automata Network - All rights reserved
      </StyledFooterCopyrights>
    </StyledFooter>
  )
}

export default Footer

const StyledFooter = styled.footer`
  margin-top: auto;
  background: ${({ theme }) => theme.colors.bg};
  padding: 0 7.81vw;
  box-shadow: 0 -0.2vw 0.2vw rgba(179, 179, 179, 0.1);

  @media (max-width: 1024px) {
    padding: 0 5.55vw;
  }

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      padding-bottom: ${pxToVw(100, 720)};
    `}
  `}
`

const StyledFooterMainContent = styled.div`
  display: flex;
  padding-top: 2.03vw;

  @media (max-width: 1024px) {
    display: block;
    padding-top: 5.41vw;
  }
`

const StyledFooterLeftColumn = styled.div`
  flex-shrink: 0;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

/*const StyledLogoStyle = styled.img`
  width: auto;
  height: 2.08vw;
  margin-right: 0.65vw;

  @media (max-width: 1024px) {
    height: 5.55vw;
    margin-right: 1.75vw;
  }
`*/

const StyledFooterMediasTitle = styled.div`
  line-height: 1em;
  font-size: 1.04vw;
  margin: 1.35vw 0;
  color: ${({ theme }) => theme.colors.gray600};

  @media (max-width: 1024px) {
    font-size: 2.5vw;
    margin: 3.61vw 0;
  }
`

const StyledFooterMedias = styled.div`
  display: flex;
`

const StyledFooterMedia = styled.a`
  display: inline-flex;
`

const StyledFooterMediaIcon = styled(Icon)`
  // height: 1.04vw;
  // height: 22px;
  margin-right: 1.04vw;

  @media (max-width: 1024px) {
    height: 4.16vw;
    margin-right: 4.16vw;
  }
`

const StyledFooterRightColumn = styled.div`
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
`

const StyledFooterLinksColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.43vw;
  margin-left: 7vw;

  &:first-child {
    margin-left: 0;
  }

  @media (max-width: 1024px) {
    margin-left: 0;
    align-items: center;
    margin-top: 7.63vw;
    width: 33.33%;
  }
`

const StyledFooterLinksColumnTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1em;
  font-weight: 500;
  font-size: 1.04vw;
  margin-bottom: 1.14vw;

  @media (max-width: 1024px) {
    font-size: 2.5vw;
    margin-bottom: 3.33vw;
  }
`

const StyledFooterLink = styled.a`
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1em;
  font-size: 0.93vw;
  margin-bottom: 1.14vw;

  &:last-child {
    margin-bottom: 0;
  }
  &:visited {
    color: ${({ theme }) => theme.colors.gray};
  }

  @media (max-width: 1024px) {
    font-size: 2.5vw;
    margin-bottom: 3.33vw;
  }
`

const StyledFooterCopyrights = styled.div`
  position: relative;
  line-height: 1em;
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.83vw;
  padding: 1.35vw 0 2.03vw;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 10.41vw;
    height: 0;
    border-top: solid 1px ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1024px) {
    font-size: 2.22vw;
    padding: 3.61vw 0 6.66vw;
    margin-top: 7.63vw;
    text-align: center;

    &::before {
      left: 50%;
      transform: translateX(-50%);
      width: 39.16vw;
    }
  }
`
